import io from 'socket.io-client';
import {forbiddenWords} from './chat-forbidden-words';
import {chatDiconnectedPopup, removeDisconnectPopup} from '../../../ui/js/chat-warning';
var translation = window['langArr'][window['language']];

export function chat(token) {
	var socket = io(CHAT_SERVER); // server location
	var name = token.slice(-5);
	var messageContainer = $('.chat-messages');
	const domain = location.host;
	var room = '';
	
	socket.on('connect', function() {
		removeDisconnectPopup();
	});

	socket.on('disconnect', function() {
		chatDiconnectedPopup();
	});
	
	// on set name button.
	$('#setName').on('click', 
		function() {
			if ($('#nameInput').val().length && socket) {
				var filteredNameInput = filter($('#nameInput').val());
				var encodedStr = filteredNameInput.replace(/[\u00A0-\u9999<>\&]/gim, function(i) {
					return '&#'+i.charCodeAt(0)+';';
				});
				name = encodedStr;
				socket.emit('new-user', {name: name, room:domain});
			}
		});

	// on set name button.
	$('#nameInput').on('keydown', 
		function(e) {
			if ($('#nameInput').val().length && socket) {
				var filteredNameInput = filter($('#nameInput').val());
				var encodedStr = filteredNameInput.replace(/[\u00A0-\u9999<>\&]/gim, function(i) {
					return '&#'+i.charCodeAt(0)+';';
				});
				name = encodedStr;
				if (e.which == 13) {
					socket.emit('new-user',  {name: name, room: domain});
				}
			}
		});	
	
		// on send message button.
   $('#startChat').on('click', 
        function() {
			if ($('#chatInput').val().length && socket) {
				var filteredInput = filter($('#chatInput').val());
				var encodedStr = filteredInput.replace(/[\u00A0-\u9999<>\&]/gim, function(i) {
					return '&#'+i.charCodeAt(0)+';';
				});
				socket.emit('send-chat-message', {message: encodedStr, room: domain});
				$('#chatInput').val('');
			}
		});

		// on set name button.
	$('#chatInput').on('keydown', 
	function(e) {
		if (e.which == 13) {
			if ($('#chatInput').val().length && socket) {
				var filteredInput = filter($('#chatInput').val());
				var encodedStr = filteredInput.replace(/[\u00A0-\u9999<>\&]/gim, function(i) {
					return '&#'+i.charCodeAt(0)+';';
				 });
				socket.emit('send-chat-message', {message: encodedStr, room: domain});
				$('#chatInput').val('');
			}
		}
	});	

	appendMessage({message: '<span style = "color:blue; text-transform:capitalize;" >'});	

	socket.emit('join-room', location.host);
	socket.on('joined-room', function(room) {
		socket.emit('new-user', {name: name, room :room});
	});
	
	socket.on('chat-message', function(msg) {
        appendMessage(msg);
	});
	
	// gets history of last messages.
	socket.on('chat-history', function(histories) {
		document.querySelector('.chat-messages') ? document.querySelector('.chat-messages').innerHTML = '' : '';
		
		histories.slice().reverse().forEach(function(history) {
			if ('ticketDetail' in history) {
				shareTicket(history.ticketDetail, history.name, history.time);
			} else {
				appendMessage({message: history.message, name: history.name, time: history.time});
			}	
		});
		var msgDiv = document.querySelector('.chat-messages');
		if (msgDiv) {
			msgDiv.scrollTop = msgDiv.scrollHeight;
		}
    });

	// Appends messages holder.
    function appendMessage(data)
    {
        var chatMessage = document.createElement('div');
        chatMessage.classList.add('chat-message');

        var chatMessageName = document.createElement('div');
		chatMessageName.classList.add('chat-message-name');
		if (data.name || data.name != undefined || data.name != null) {
			data.name == name ? chatMessageName.innerHTML = '<span style="color:blue"> ' + data.name + ' :<span>' : chatMessageName.innerText = data.name + ' :';
		}

        var chatMessageText = document.createElement('div');
        chatMessageText.classList.add('chat-message-text');
		chatMessageText.innerHTML = data.message;
		
		var chatMessageTime = document.createElement('div');
		chatMessageTime.classList.add('chat-message-time');
		chatMessageTime.innerHTML = data.time;

        chatMessage.append(chatMessageName);
		chatMessage.append(chatMessageText);
		data.time ? chatMessageText.append(chatMessageTime) : '';
		messageContainer.append(chatMessage);
		
		var msgDiv = document.querySelector('.chat-messages');
		if (msgDiv) {
			msgDiv.scrollTop = msgDiv.scrollHeight;
		}
	}

	// Appends messages holder.
    function shareTicket(data, sharedName, time)
    {	
		var html = generateHtml(data, sharedName, time);

        var ticketHolder = document.createElement('div');
        ticketHolder.classList.add('shared-ticket');

		var sharedTicket = document.createElement('div');
		sharedTicket.innerHTML = html;
		ticketHolder.append(sharedTicket);

		messageContainer.append(ticketHolder);

		var msgDiv = document.querySelector('.chat-messages');
		msgDiv.scrollTop = msgDiv.scrollHeight;
	}
	
	window.addEventListener('loggedOut', function (e) {
		disconnect();

		socket = undefined;
		$('#nameInput').val('');
	}, false);

	// Force Disconnect.
	function disconnect()
	{
		if (domain && socket) {
			socket.disconnect(domain);
		}
	}

	window.addEventListener('shareTicketEvent', function (e) {
		socket.emit('shareTicket', { room: domain, ticketDetail: e.detail });
	});

	socket.on('sharedTicket', function(ticketData) {
        shareTicket(ticketData.ticketDetail, ticketData.name , ticketData.time);
	});

	function generateHtml(data, sharedName, time) {
		
		let html = '';	
		
		if (!("ticketHTML" in data)) {
		html +=  
			'<div id="shareTicketHolder">' + 
				'<div id="shareName" class="share-name"><span>' + sharedName + '</span><span>' + time + '</span></div>';

			if (data.matchedNumbers.length > 0) {
				html += '<div class="ticket-ball-holder" >';
				data.selectedNumbers.forEach(function(number, index){

					let classCss = '';
					data.matchedNumbers.forEach(function(match){
						if (match === number) {
							classCss = 'ticket-ball-bck-drawn';
						}
					});

					html += 
					'<div class="ticket-ball-bck ' + classCss + '">' + 
						'<div class="ticket-ball ticket-ball-ns ' + getBallColor(number) + '-ball">' + 
							'<div class="ticket-ball-number">' + number + '</div>' + 
						'</div>     '                  + 
						'<div class="kvacica">' + 
						'</div>' + 
					'</div>';
				});

				html += '</div>';
			}
		
			if (Object.keys(data.all_colors).length > 0) {

				html += '<div class="ticket-ball-holder" >';

				html += `<div class="bhr-content">
					<div class="bhr-balls ${data.all_colors['red'] >= 6 ?  'bhr-balls-choosen bhr-balls-choosen-red'  : ''}" id="all-color-red" data-color="red"><img alt="red-ball" src="img/red-ball.png"></div>
					<div class="bhr-balls ${data.all_colors['green'] >= 6 ?  'bhr-balls-choosen bhr-balls-choosen-green' : ''}" id="all-color-green" data-color="green"><img alt="green-ball" src="img/green-ball.png"></div>
					<div class="bhr-balls ${data.all_colors['blue'] >= 6 ?  'bhr-balls-choosen bhr-balls-choosen-blue'  : ''}" id="all-color-blue" data-color="blue"><img alt="blue-ball" src="img/blue-ball.png"></div>
					<div class="bhr-balls ${data.all_colors['purple'] >= 6 ?  'bhr-balls-choosen bhr-balls-choosen-purple' : ''}" id="all-color-purple" data-color="purple"><img alt="purple-ball" src="img/purple-ball.png"></div>
					<div class="bhr-balls ${data.all_colors['brown'] >= 6 ?  'bhr-balls-choosen bhr-balls-choosen-brown' : ''}" id="all-color-brown" data-color="brown" ><img alt="brown-ball" src="img/brown-ball.png"></div>
					<div class="bhr-balls ${data.all_colors['yellow'] >= 6 ?  'bhr-balls-choosen bhr-balls-choosen-yellow' : ''}" id="all-color-yellow" data-color="yellow"><img alt="yellow-ball" src="img/yellow-ball.png"></div>
					<div class="bhr-balls ${data.all_colors['orange'] >= 6 ?  'bhr-balls-choosen bhr-balls-choosen-orange' : ''}" id="all-color-orange" data-color="orange"><img alt="orange-ball" src="img/orange-ball.png"></div>
					<div class="bhr-balls ${data.all_colors['black'] >= 6 ?  'bhr-balls-choosen bhr-balls-choosen-black'  : ''}" id="all-color-black" data-color="black" ><img alt="black-ball" src="img/black-ball.png"></div>
				</div>`;

				html += '</div>';
			} else {
				Object.keys(data).forEach(function(key){
					if (typeof data[key] === 'string' || data[key] instanceof String) {
						if (data[key].length > 0) {
							var nameKEy = '';
							if (key == 'preballs_sum') {
								nameKEy = 'first_ball';
							} else {
								nameKEy = key;
							}

							html +=  
								'<div id="shareOther">' + 
								translation[nameKEy].toUpperCase() + ' :  <span class="green">' +  translation[data[key].toLowerCase()].toUpperCase() + '</span>' + 
								'</div>';
						}
					}
				});
			}
			
			if (Number(data.ticketStatus) === 3) {
				let winMoney = Number(data.winMoney) + Number(data.bonusMoney) + Number(data.happyGameMoney) + Number(data.happyGameMoney);
				
				html +=  
				'<div id="shareWinData" >' + 
					'<p>' + translation['win_multiplier'] + ': <span class="green">' + parseInt((winMoney / data.ticketAmount)) + '</span></p>' + 
					'<p>' + translation['win_amount'] + ':  <span class="green"> ' + parseInt(winMoney).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,') + ' ' + getFromCookie('currency') + '</span></p>' + 
				'</div>' + 
			'</div>';
			}

			if (Number(data.ticketStatus) === 4) {
				let winMoney = Number(data.payout);
			
				html +=  
				'<div id="shareWinData" >' + 
					'<p>' + translation['win_multiplier'] + ': <span class="green">' + parseInt((winMoney / data.ticketAmount)) + '</span></p>' + 
					'<p>' + translation['win_amount'] + ':  <span class="green"> ' + parseInt(winMoney).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,') + ' ' + getFromCookie('currency') + '</span></p>' + 
				'</div>' + 
			'</div>';
			}
		} else {
			if (data.winStatus === true || !("winStatus" in data)) {
				html +=  
				'<div id="shareTicketHolder">' + 
					'<div id="shareName" class="share-name"><span>' + sharedName + '</span><span>' + time + '</span></div>';
	
				if (data.sharedData.matchedNumbers.length > 0) {
					html += '<div class="ticket-ball-holder" >';
					data.selectedNumbers.forEach(function(number, index){
	
						let classCss = '';
						data.sharedData.matchedNumbers.forEach(function(match){
							if (match === number) {
								classCss = 'ticket-ball-bck-drawn';
							}
						});
	
						html += 
						'<div class="ticket-ball-bck ' + classCss + '">' + 
							'<div class="ticket-ball ticket-ball-ns ' + getBallColor(number) + '-ball">' + 
								'<div class="ticket-ball-number">' + number + '</div>' + 
							'</div>     '                  + 
							'<div class="kvacica">' + 
							'</div>' + 
						'</div>';
					});
	
					html += '</div>';
				}
			
				if (Object.keys(data.sharedData.all_colors).length > 0) {
	
					html += '<div class="ticket-ball-holder" >';
	
					html += `<div class="bhr-content">
						<div class="bhr-balls ${data.sharedData.all_colors['red'] >= 6 ?  'bhr-balls-choosen bhr-balls-choosen-red'  : ''}" id="all-color-red" data-color="red"><img alt="red-ball" src="img/red-ball.png"></div>
						<div class="bhr-balls ${data.sharedData.all_colors['green'] >= 6 ?  'bhr-balls-choosen bhr-balls-choosen-green' : ''}" id="all-color-green" data-color="green"><img alt="green-ball" src="img/green-ball.png"></div>
						<div class="bhr-balls ${data.sharedData.all_colors['blue'] >= 6 ?  'bhr-balls-choosen bhr-balls-choosen-blue'  : ''}" id="all-color-blue" data-color="blue"><img alt="blue-ball" src="img/blue-ball.png"></div>
						<div class="bhr-balls ${data.sharedData.all_colors['purple'] >= 6 ?  'bhr-balls-choosen bhr-balls-choosen-purple' : ''}" id="all-color-purple" data-color="purple"><img alt="purple-ball" src="img/purple-ball.png"></div>
						<div class="bhr-balls ${data.sharedData.all_colors['brown'] >= 6 ?  'bhr-balls-choosen bhr-balls-choosen-brown' : ''}" id="all-color-brown" data-color="brown" ><img alt="brown-ball" src="img/brown-ball.png"></div>
						<div class="bhr-balls ${data.sharedData.all_colors['yellow'] >= 6 ?  'bhr-balls-choosen bhr-balls-choosen-yellow' : ''}" id="all-color-yellow" data-color="yellow"><img alt="yellow-ball" src="img/yellow-ball.png"></div>
						<div class="bhr-balls ${data.sharedData.all_colors['orange'] >= 6 ?  'bhr-balls-choosen bhr-balls-choosen-orange' : ''}" id="all-color-orange" data-color="orange"><img alt="orange-ball" src="img/orange-ball.png"></div>
						<div class="bhr-balls ${data.sharedData.all_colors['black'] >= 6 ?  'bhr-balls-choosen bhr-balls-choosen-black'  : ''}" id="all-color-black" data-color="black" ><img alt="black-ball" src="img/black-ball.png"></div>
					</div>`;
	
					html += '</div>';
				} else {
					Object.keys(data.sharedData).forEach(function(key){
						if (typeof data.sharedData[key] === 'string' || data.sharedData[key] instanceof String) {
							if (data.sharedData[key].length > 0) {
								var nameKEy = '';
								if (key == 'preballs_sum') {
									nameKEy = 'first_ball';
								} else {
									nameKEy = key;
								}
	
								html +=  
									'<div id="shareOther">' + 
									translation[nameKEy].toUpperCase() + ' :  <span class="green">' +  translation[data.sharedData[key].toLowerCase()].toUpperCase() + '</span>' + 
									'</div>';
							}
						}
					});
				}
	
				if (Number(data.ticketStatus) === 2) {
					let winMoney = Number(data.winMoney) + Number(data.bonusMoney) + Number(data.happyGameMoney) + Number(data.happyGameMoney);
					
					html +=  
					'<div id="lostShareTicket" >' + 
						'LOST' + 
					'</div>' + 
				'</div>';
				}
				
				if (Number(data.ticketStatus) === 3) {
					let winMoney = Number(data.winMoney) + Number(data.bonusMoney) + Number(data.happyGameMoney) + Number(data.happyGameMoney);
					
					html +=  
					'<div id="shareWinData" >' + 
						'<p>' + translation['win_multiplier'] + ': <span class="green">' + parseInt((winMoney / data.ticketAmount)) + '</span></p>' + 
						'<p>' + translation['win_amount'] + ':  <span class="green"> ' + parseInt(winMoney).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,') + ' ' + getFromCookie('currency') + '</span></p>' + 
					'</div>' + 
				'</div>';
				}
	
				if (Number(data.ticketStatus) === 4) {
					let winMoney = Number(data.payout);
				
					html +=  
					'<div id="shareWinData" >' + 
						'<p>' + translation['win_multiplier'] + ': <span class="green">' + parseInt((winMoney / data.ticketAmount)) + '</span></p>' + 
						'<p>' + translation['win_amount'] + ':  <span class="green"> ' + parseInt(winMoney).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,') + ' ' + getFromCookie('currency') + '</span></p>' + 
					'</div>' + 
				'</div>';
				}
			} else {
				if (Number(data.ticketStatus) === 2 && Number(data.drawnNumbers) >= 35) {
					html = data.ticketHTML.replace('str-ticket-bar-use', 'lost-ticket-show')
						.replace('str-left-use', sharedName)
						.replace('str-right-use', time)
						.replace('str-lost-use', 'LOST' );
				} else {
					html = data.ticketHTML.replace('str-left-use', sharedName)
						.replace('str-right-use', time)
						.replace('str-lost-use', '' );
				}
			}
		}
		
		return html;
	}

	// Add leading zero if less than 10 (for hours / minutes)
	function checkTime(i)
    {
        return (i < 10) ? "0" + i : i;
	}
	
	// Gets words from camel case variables.
	function camelCaseToWords(word)
	{
		return word.replace(/([A-Z]+)/g, " $1").replace(/([A-Z][a-z])/g, " $1").toUpperCase();
	}

	// Gets Ball Color By Number.
 	function getBallColor(ballNumber) {  

		const colors = {
			'red': [1,9,17,25,33,41],
			'green': [2,10,18,26,34,42],
			'blue': [3,11,19,27,35,43],
			'purple': [4,12,20,28,36,44],
			'brown': [5,13,21,29,37,45],
			'yellow': [6,14,22,30,38,46],
			'orange': [7,15,23,31,39,47],
			'black': [8,16,24,32,40,48]
			};

		for (var key in colors) {
			if (colors[key].indexOf(Number(ballNumber)) >= 0) {
				
				return key;
			}
		}
	}

	function getFromCookie(key) {
    
		var pair = document.cookie.match(new RegExp(key + '=([^;]+)'));
		 return !!pair ? pair[1] : '';
	}
	
	function filter(input) {

		if (input) {
			var words = input.split(" ");
			var withoutDialects = [];
			
			for (var i = 0; i < words.length; i ++) {
				withoutDialects.push(forbiddenWords.includes((words[i].normalize("NFD").replace(/[\u0300-\u036f]/g, "")).replace(/[đ]/g,'dj').replace(/[Đ]/g,'DJ').toLowerCase()) ?
					words[i].replace(/./g, '*') : words[i]);
			}

			var output = withoutDialects.join(' ');
			return output;
		}
		
		return input;
	}
}



//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/js/chat.js
// module id = 31
// module chunks = 11